import { TERTIARY, makeThemeColor } from '@tornado-rdk/theme';
import { TRANSPARENT } from '../../../tornado/utils/colors';
import { makeDefaultStylingContext } from '../../../tornado/utils/style';
import { SCREEN_HEIGHT, SCREEN_WIDTH } from '../../../tornado/utils/sizes';

export const defaultContext = makeDefaultStylingContext();

export const WIDTH = {
  ...SCREEN_WIDTH,
};

export const HEIGHT = {
  ...SCREEN_HEIGHT,
};

export const colors = {
  background: makeThemeColor(TERTIARY),
  transparent: TRANSPARENT,
};

export const getInitialStyle = (context = defaultContext) => {
  const { screenSize } = context;

  return {
    w: WIDTH[screenSize],
    h: HEIGHT[screenSize],
    Widgets: {
      SnackBar: {
        w: WIDTH[screenSize],
        y: HEIGHT[screenSize],
        mountY: 1,
      },
    },
  };
};
